import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField } from "sprint-common-web";

import { useImportArchiveBucketForm } from "./useImportArchiveForm";

export interface ImportArchiveBucketFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface ImportArchiveBucketFormInputs {
    uniqueId: string;
}

export const ImportArchiveBucketForm: FunctionComponent<ImportArchiveBucketFormProps> = (
    props: ImportArchiveBucketFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<ImportArchiveBucketFormInputs>({
        defaultValues: {
            uniqueId: ""
        },
        criteriaMode: "all"
    });

    const { addImportBucketArchive, validateUniqueId } = useImportArchiveBucketForm();

    const handleCreateBucket = async ({ uniqueId }: ImportArchiveBucketFormInputs) => {
        await addImportBucketArchive({ uniqueId });
        props.onSubmit();

        reset();
    };

    const handleCancel = () => {
        reset();

        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateBucket)}>
            <FormFields>
                <>
                    <FormTextField
                        name="uniqueId"
                        label="Bucket Unique Id"
                        control={control}
                        errors={errors}
                        rules={{
                            required: "Enter bucket unique id",
                            validate: validateUniqueId
                        }}
                    />
                </>
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancel} />
        </Form>
    );
};
